import { _ as _$1 } from '@swc/helpers/esm/_object_spread.js';
import { _ } from '@swc/helpers/esm/_object_without_properties.js';
import { cx } from 'instantsearch-ui-components';
import { h } from 'preact';
import { InternalHighlight } from '../InternalHighlight/InternalHighlight.js';

function ReverseHighlight(_0) {
    var _0_classNames = _0.classNames, classNames = _0_classNames === void 0 ? {} : _0_classNames, props = _(_0, [
        "classNames"
    ]);
    return /*#__PURE__*/ h(InternalHighlight, _$1({
        classNames: {
            root: cx('ais-ReverseHighlight', classNames.root),
            highlighted: cx('ais-ReverseHighlight-highlighted', classNames.highlighted),
            nonHighlighted: cx('ais-ReverseHighlight-nonHighlighted', classNames.nonHighlighted),
            separator: cx('ais-ReverseHighlight-separator', classNames.separator)
        }
    }, props));
}

export { ReverseHighlight };
